import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import TreeSet from '../../../../../../java/util/TreeSet';
import GeometryTransformer from '../../../geom/util/GeometryTransformer';
import hasInterface from '../../../../../../hasInterface';
import Double from '../../../../../../java/lang/Double';
import LineStringSnapper from './LineStringSnapper';
import PrecisionModel from '../../../geom/PrecisionModel';
import Polygonal from '../../../geom/Polygonal';
var GeometrySnapper = /*#__PURE__*/function () {
  function GeometrySnapper() {
    _classCallCheck(this, GeometrySnapper);
    GeometrySnapper.constructor_.apply(this, arguments);
  }
  _createClass(GeometrySnapper, [{
    key: "snapTo",
    value: function snapTo(snapGeom, snapTolerance) {
      var snapPts = this.extractTargetCoordinates(snapGeom);
      var snapTrans = new SnapTransformer(snapTolerance, snapPts);
      return snapTrans.transform(this._srcGeom);
    }
  }, {
    key: "snapToSelf",
    value: function snapToSelf(snapTolerance, cleanResult) {
      var snapPts = this.extractTargetCoordinates(this._srcGeom);
      var snapTrans = new SnapTransformer(snapTolerance, snapPts, true);
      var snappedGeom = snapTrans.transform(this._srcGeom);
      var result = snappedGeom;
      if (cleanResult && hasInterface(result, Polygonal)) result = snappedGeom.buffer(0);
      return result;
    }
  }, {
    key: "computeSnapTolerance",
    value: function computeSnapTolerance(ringPts) {
      var minSegLen = this.computeMinimumSegmentLength(ringPts);
      var snapTol = minSegLen / 10;
      return snapTol;
    }
  }, {
    key: "extractTargetCoordinates",
    value: function extractTargetCoordinates(g) {
      var ptSet = new TreeSet();
      var pts = g.getCoordinates();
      for (var i = 0; i < pts.length; i++) ptSet.add(pts[i]);
      return ptSet.toArray(new Array(0).fill(null));
    }
  }, {
    key: "computeMinimumSegmentLength",
    value: function computeMinimumSegmentLength(pts) {
      var minSegLen = Double.MAX_VALUE;
      for (var i = 0; i < pts.length - 1; i++) {
        var segLen = pts[i].distance(pts[i + 1]);
        if (segLen < minSegLen) minSegLen = segLen;
      }
      return minSegLen;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._srcGeom = null;
      var srcGeom = arguments[0];
      this._srcGeom = srcGeom;
    }
  }, {
    key: "snap",
    value: function snap(g0, g1, snapTolerance) {
      var snapGeom = new Array(2).fill(null);
      var snapper0 = new GeometrySnapper(g0);
      snapGeom[0] = snapper0.snapTo(g1, snapTolerance);
      var snapper1 = new GeometrySnapper(g1);
      snapGeom[1] = snapper1.snapTo(snapGeom[0], snapTolerance);
      return snapGeom;
    }
  }, {
    key: "computeOverlaySnapTolerance",
    value: function computeOverlaySnapTolerance() {
      if (arguments.length === 1) {
        var g = arguments[0];
        var snapTolerance = GeometrySnapper.computeSizeBasedSnapTolerance(g);
        var pm = g.getPrecisionModel();
        if (pm.getType() === PrecisionModel.FIXED) {
          var fixedSnapTol = 1 / pm.getScale() * 2 / 1.415;
          if (fixedSnapTol > snapTolerance) snapTolerance = fixedSnapTol;
        }
        return snapTolerance;
      } else if (arguments.length === 2) {
        var g0 = arguments[0],
          g1 = arguments[1];
        return Math.min(GeometrySnapper.computeOverlaySnapTolerance(g0), GeometrySnapper.computeOverlaySnapTolerance(g1));
      }
    }
  }, {
    key: "computeSizeBasedSnapTolerance",
    value: function computeSizeBasedSnapTolerance(g) {
      var env = g.getEnvelopeInternal();
      var minDimension = Math.min(env.getHeight(), env.getWidth());
      var snapTol = minDimension * GeometrySnapper.SNAP_PRECISION_FACTOR;
      return snapTol;
    }
  }, {
    key: "snapToSelf",
    value: function snapToSelf(geom, snapTolerance, cleanResult) {
      var snapper0 = new GeometrySnapper(geom);
      return snapper0.snapToSelf(snapTolerance, cleanResult);
    }
  }]);
  return GeometrySnapper;
}();
export { GeometrySnapper as default };
GeometrySnapper.SNAP_PRECISION_FACTOR = 1e-9;
var SnapTransformer = /*#__PURE__*/function (_GeometryTransformer) {
  _inherits(SnapTransformer, _GeometryTransformer);
  function SnapTransformer() {
    var _this;
    _classCallCheck(this, SnapTransformer);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SnapTransformer).call(this));
    SnapTransformer.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(SnapTransformer, [{
    key: "snapLine",
    value: function snapLine(srcPts, snapPts) {
      var snapper = new LineStringSnapper(srcPts, this._snapTolerance);
      snapper.setAllowSnappingToSourceVertices(this._isSelfSnap);
      return snapper.snapTo(snapPts);
    }
  }, {
    key: "transformCoordinates",
    value: function transformCoordinates(coords, parent) {
      var srcPts = coords.toCoordinateArray();
      var newPts = this.snapLine(srcPts, this._snapPts);
      return this._factory.getCoordinateSequenceFactory().create(newPts);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._snapTolerance = null;
      this._snapPts = null;
      this._isSelfSnap = false;
      if (arguments.length === 2) {
        var snapTolerance = arguments[0],
          snapPts = arguments[1];
        this._snapTolerance = snapTolerance;
        this._snapPts = snapPts;
      } else if (arguments.length === 3) {
        var _snapTolerance = arguments[0],
          _snapPts = arguments[1],
          isSelfSnap = arguments[2];
        this._snapTolerance = _snapTolerance;
        this._snapPts = _snapPts;
        this._isSelfSnap = isSelfSnap;
      }
    }
  }]);
  return SnapTransformer;
}(GeometryTransformer);